import React from 'react';
import Skeleton from 'react-loading-skeleton';

/**
 * Skeleton loader for Product Detail Page
 * Complete layout matching [id]/page.tsx
 */
export const ProductDetailSkeleton: React.FC = () => {
  return (
    <main className="organic min-h-screen">
    <div className="max-w-7xl mx-auto" style={{ padding: 'calc(64px + var(--space-6)) clamp(20px, 4vw, 48px) calc(var(--space-8) * 2)' }}>
      <div className="grid grid-cols-1 md:grid-cols-2" style={{ gap: 'var(--space-8)' }}>
        {/* Left Column - Product Images */}
        <div>
          <div style={{ marginBottom: 'var(--space-3)', borderRadius: 'var(--radius-lg)', overflow: 'hidden' }}>
            <Skeleton height={600} />
          </div>

          <div className="grid grid-cols-4" style={{ gap: 'var(--space-2)' }}>
            {Array.from({ length: 4 }).map((_, i) => (
              <Skeleton key={i} height={96} borderRadius={12} />
            ))}
          </div>
        </div>

        {/* Right Column - Product Info */}
        <div>
          <Skeleton height={32} style={{ marginBottom: 'var(--space-2)' }} />
          <Skeleton width={120} height={28} style={{ marginBottom: 'var(--space-4)' }} />

          <div style={{ marginBottom: 'var(--space-4)' }}>
            <Skeleton width={140} height={16} />
          </div>

          <div style={{ marginBottom: 'var(--space-6)' }}>
            <Skeleton count={3} />
          </div>

          <div className="card elev-sm" style={{ padding: 'var(--space-4)', marginBottom: 'var(--space-6)' }}>
            <div className="flex flex-col" style={{ gap: 'var(--space-3)' }}>
              <div>
                <Skeleton width={100} height={16} style={{ marginBottom: 6 }} />
                <div className="flex gap-2">
                  <Skeleton width={70} height={24} borderRadius={999} />
                  <Skeleton width={70} height={24} borderRadius={999} />
                  <Skeleton width={70} height={24} borderRadius={999} />
                </div>
              </div>
              <Skeleton width={150} height={14} />
              <Skeleton width={180} height={14} />
            </div>
          </div>

          <div style={{ marginBottom: 'var(--space-6)' }}>
            <Skeleton width={90} height={16} style={{ marginBottom: 'var(--space-2)' }} />
            <Skeleton width={120} height={36} borderRadius={999} />
          </div>

          <div style={{ marginBottom: 'var(--space-6)' }}>
            <Skeleton height={48} borderRadius={16} />
          </div>

          <Skeleton height={44} borderRadius={999} style={{ marginBottom: 'var(--space-2)' }} />
          <Skeleton height={48} borderRadius={999} />
        </div>
      </div>

      <div style={{ marginTop: 'calc(var(--space-8) * 1.6)' }}>
        <div className="flex gap-2" style={{ marginBottom: 'var(--space-6)' }}>
          <Skeleton width={110} height={36} borderRadius={999} />
          <Skeleton width={110} height={36} borderRadius={999} />
          <Skeleton width={110} height={36} borderRadius={999} />
        </div>

        <div className="flex flex-col" style={{ gap: 'var(--space-3)' }}>
          <Skeleton width={200} height={22} />
          <Skeleton count={4} />

          <div className="grid grid-cols-1 md:grid-cols-2" style={{ gap: 'var(--space-3)', marginTop: 'var(--space-4)' }}>
            <Skeleton height={100} borderRadius={16} />
            <Skeleton height={100} borderRadius={16} />
          </div>
        </div>
      </div>
    </div>
    </main>
  );
};

export default ProductDetailSkeleton;
